export default "__VITE_ASSET__DrUiVZRw__"